import { Route, Routes } from "react-router-dom";
import { GuestListCard } from "./components/GuestListCard";
import { Home } from "./containers/Home";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/guests" element={<GuestListCard />} />
    </Routes>
  );
}

export default App;
